import {
  Component,
  OnInit,
  OnDestroy,
  Optional,
  SimpleChanges,
} from "@angular/core";
import { StoresService } from "src/app/services/catalog/stores.service";
import { SlotService } from "src/app/services/slot/slot.service";
import { ChangeDetectorRef } from "@angular/core";
import { OrderService } from "../../../services/order.service";
import { Router } from "@angular/router";
import { MatDialogRef } from "@angular/material/dialog";
import socketClient from "socket.io-client";
import { promise } from "../../liveshop/utils/socket-promise";
import { environment } from "src/environments/environment";
import {
  CdkVirtualScrollViewport,
  ScrollDispatcher,
} from "@angular/cdk/scrolling";
import { LocationService } from "src/app/services/location-service/location.service";
import { DateFormatService } from "src/app/services/common/date-format.service";

@Component({
  selector: "app-notifications",
  templateUrl: "./notifications.component.html",
  styleUrls: ["./notifications.component.scss"],
})
export class NotificationsComponent implements OnInit, OnDestroy {
  isSocketInitiated = false;
  limit = 20;
  skipCount = 0;
  isNotificationsFetch = true;
  constructor(
    @Optional() private dialogRef: MatDialogRef<NotificationsComponent>,
    public orderService: OrderService,
    public storesService: StoresService,
    private slotService: SlotService,
    private changeDetector: ChangeDetectorRef,
    private scrollDispatcher: ScrollDispatcher,
    private cdkRef: ChangeDetectorRef,
    public router: Router,
    public locationService: LocationService,
    public dateFormatService: DateFormatService
  ) {}

  getNotificationsList(event) {
    if (
      Math.ceil(event.target.scrollHeight - event.target.scrollTop) <=
      event.target.clientHeight + 10
    ) {
      if (this.isNotificationsFetch) {
        let count = 0;
        this.skipCount += this.limit;
        this.slotService
          .getNotifications(this.limit, this.skipCount)
          .subscribe((notifications) => {
            if (notifications && notifications.length) {
              notifications.forEach((element) => {
                count += element.notifications.length;
                element.notifications.sort((a, b) =>
                  a.created > b.created ? -1 : b.created > a.created ? 1 : 0
                );
              });
              if (
                this.storesService.notifications &&
                this.storesService.notifications.length
              ) {
                if (
                  this.storesService.notifications[
                    this.storesService.notifications.length - 1
                  ]._id === notifications[0]._id
                ) {
                  this.storesService.notifications[
                    this.storesService.notifications.length - 1
                  ].notifications = [
                    ...this.storesService.notifications[
                      this.storesService.notifications.length - 1
                    ].notifications,
                    ...notifications[0].notifications,
                  ];
                  notifications = notifications.slice(1);
                  this.storesService.notifications = [
                    ...this.storesService.notifications,
                    ...notifications,
                  ];
                } else {
                  this.storesService.notifications = [
                    ...this.storesService.notifications,
                    ...notifications,
                  ];
                }
                this.isNotificationsFetch = count < 20 ? false : true;
                this.cdkRef.detectChanges();
              } else {
                this.storesService.notifications = notifications;
              }
            } else {
              this.isNotificationsFetch = false;
            }
          });
      }
    }
  }

  ngOnInit(): void {
    this.dateFormatService.formatDates();
    this.limit = 20;
    this.skipCount = 0;
    let count = 0;
    this.storesService.notifications = null;
    //this.notificationsList(this.limit, this.skipCount);
    this.slotService
      .getNotifications(this.limit, this.skipCount)
      .subscribe((notifications) => {
        notifications.forEach((element) => {
          count += element.notifications.length;
          element.notifications.sort((a, b) =>
            a.created > b.created ? -1 : b.created > a.created ? 1 : 0
          );
        });
        this.isNotificationsFetch = count < 20 ? false : true;
        this.storesService.notifications = notifications;
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dateFormatService.formatDates();
  }

  getTitle(notification) {
    return (
      notification?.type +
      " " +
      notification?.title?.split(" ")[
        notification?.title?.split(" ")?.length - 1
      ]
    );
  }

  getUser(notification) {
    return (
      notification?.buyer?.name +
      " has " +
      notification?.title?.split(" ")[
        notification?.title?.split(" ")?.length - 1
      ] +
      " " +
      notification?.type
    );
  }

  getDate(isoDate) {
    let date = new Date(isoDate);
    let temp = date.toString().split(" ");
    let wholeDate = temp[1] + " " + temp[2] + " " + temp[3];
    let curDate = new Date();
    let curTemp = curDate.toString().split(" ");
    let wholeCurDate = curTemp[1] + " " + curTemp[2] + " " + curTemp[3];
    if (wholeCurDate === wholeDate) {
      return "TODAY";
    } else {
      return wholeDate;
    }
  }

  getTime(notification) {
    let date = new Date(notification.created);
    let time = date.toString().split(" ")[4];
    let hour = Number(time.split(":")[0]);
    let meridian = hour < 12 ? "AM" : "PM";
    let min = time.split(":")[1];
    hour = ((hour + 11) % 12) + 1;

    return hour.toString() + ":" + min + " " + meridian;
  }

  clearNotifications(type) {
    this.limit = 20;
    this.skipCount = 0;
    this.slotService.clearNotifications(type, true).subscribe((res) => {
      this.storesService.notificationCount = 0;
      if (type === "clearall") {
        this.storesService.notifications = null;
      } else {
        this.isNotificationsFetch = true;
        this.ngOnInit();
      }
    });
  }

  openOrder(notification) {
    notification.viewed = true;
    this.slotService.updateNotification(notification).subscribe((res) => {});
    this.slotService.openOrder.next(notification.source.order);
    if (this.storesService.notificationCount) {
      this.storesService.notificationCount -= 1;
    }
    this.router.navigateByUrl("/myorders");
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }

  getIcon(notification) {
    let src = "";
    const type = notification.title.split(" ")[
      notification.title.split(" ").length - 1
    ];
    if (type === "Cancelled") {
      src = "assets/icons/cancel-2.svg";
    } else if (type === "Placed") {
      src = "assets/icons/shopping-bag.svg";
    } else {
      src = "assets/icons/return.svg";
    }
    return src;
  }

  ngOnDestroy() {}
}
